import { WarningAmberRounded } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import React from 'react'

interface PaymentFailureProps {
    title: string
    subtitle: string
    primaryButtonText: string
    onBackClick: (isReloadRequired: boolean) => void
    secondaryButtonText?: string
    onSecondaryClick?: () => void
}

const PaymentFailure: React.FC<PaymentFailureProps> = ({
    title,
    subtitle,
    primaryButtonText,
    onBackClick,
    secondaryButtonText,
    onSecondaryClick
}) => {
    return (
        <Box
            sx={{
                marginTop: { xs: '150px', md: '250px' },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 2, md: 3 },
                py: { xs: 4, md: 6 },
                bgcolor: 'background.default'
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <Box
                    sx={{
                        width: { xs: 60, md: 85 },
                        height: { xs: 60, md: 85 },
                        borderRadius: '50%',
                        bgcolor: 'error.light',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 3
                    }}
                >
                    <WarningAmberRounded
                        sx={{
                            fontSize: { xs: 40, md: 64 }
                        }}
                        color="error"
                    />
                </Box>

                <Typography
                    variant="h4"
                    sx={{
                        color: 'text.primary',
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { xs: '1.5rem', md: '2.125rem' }
                    }}
                >
                    {title}
                </Typography>

                <Box
                    sx={{
                        mb: 3,
                        maxWidth: { xs: 320, md: 450 }
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: { xs: 14, md: 16 },
                            color: 'text.secondary',
                            lineHeight: 1.8
                        }}
                    >
                        {subtitle}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                        width: { xs: '100%', sm: 'auto' },
                        mt: 2
                    }}
                >
                    <Button
                        variant="customVariantPrimary"
                        onClick={() => onBackClick(true)}
                        sx={{
                            px: 4,
                            py: 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                            width: { xs: '100%', sm: 'auto' }
                        }}
                    >
                        {primaryButtonText}
                    </Button>

                    {secondaryButtonText && onSecondaryClick && (
                        <Button
                            variant="outlined"
                            onClick={onSecondaryClick}
                            sx={{
                                px: 4,
                                py: 1.5,
                                textTransform: 'none',
                                fontWeight: 600,
                                width: { xs: '100%', sm: 'auto' }
                            }}
                        >
                            {secondaryButtonText}
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export { PaymentFailure }
export type { PaymentFailureProps }
